/**
 * @namespace geo.gui
 */
module.exports = {
  colorLegendWidget: require('./colorLegendWidget'),
  domWidget: require('./domWidget'),
  legendWidget: require('./legendWidget'),
  scaleWidget: require('./scaleWidget'),
  sliderWidget: require('./sliderWidget'),
  svgWidget: require('./svgWidget'),
  uiLayer: require('./uiLayer'),
  widget: require('./widget')
};
